import React from 'react';
import { connect } from 'react-redux';
import { getParticleShapeSrc } from '../../../../../../utilities/imageUtilities';

const PARTICLE_PREVIEW_SIZE = 20;

const ShapePreview = ({ shape, mediaData, color }) => {
    const src = getParticleShapeSrc(shape, mediaData);
    const hexColor = color ? color.replace('0x', '#') : '#fbfbfb';

    return (
        <div style={{
            position: 'relative',
            width: PARTICLE_PREVIEW_SIZE,
            height: PARTICLE_PREVIEW_SIZE,
        }}>
            <img src={src} alt={shape} style={{
                width: PARTICLE_PREVIEW_SIZE,
                height: PARTICLE_PREVIEW_SIZE,
                objectFit: 'contain',
                display: 'block',
            }} />
            <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: PARTICLE_PREVIEW_SIZE,
                height: PARTICLE_PREVIEW_SIZE,
                backgroundColor: hexColor,
                mixBlendMode: 'multiply',
                pointerEvents: 'none',
                WebkitMaskImage: `url(${src})`,
                WebkitMaskSize: 'contain',
                WebkitMaskRepeat: 'no-repeat',
                WebkitMaskPosition: 'center',
                maskImage: `url(${src})`,
                maskSize: 'contain',
                maskRepeat: 'no-repeat',
                maskPosition: 'center',
            }} />
        </div>
    );
};

const mapStateToProps = (state, ownProps) => {
    const particleElement = state.createPreview.present.videoSettings.elements.particles.items[ownProps.index];
    return {
        shape: particleElement?.shape,
        mediaData: particleElement?.mediaData,
        color: particleElement?.color
    };
};

export default connect(mapStateToProps)(ShapePreview);
